<template>
  <div class="evalua_page-root org_create_evalua-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="backComfim=true" class="nav-wrap">
        <p class="title">{{classInfo.name}}</p>
      </yioks-page-nav>
      <div class="content-wrap">
        <user :class-info="classInfo" :dataPhase="dataPhase" ></user>
        <!-- <p class="evalua-tip">请根据中国足协要求，依据实际情况认真填写问卷调查，这样会有助于国家足球体育的不断进步！</p> -->
        <div class="evalua-wrap">
          <div class="scroll-wrap">
            <vue-scroll :ops="$options._myOpt.vuescrollOpt">
              <div class="scroll-content">
                <!-- <div class="evaluat-box" v-for="item in offTeacher" :key="item.id">
                  <div class="title">
                    <v-icon class="icon" name='regular/edit' scale="2"></v-icon>
                    <span class="text">对主讲师{{item.name}}的问卷调查</span>
                  </div>
                  <yioks-rating class="rating" :star-num.sync='item.starNum'></yioks-rating>
                  <p class="cont-title">存在以下现象</p>
                  <yioks-evaluation class="cont-box" :conts-list.sync='item.contsList'></yioks-evaluation>
                  <p class="cont-title">其他意见</p>
                  <div class="textarea-wrap">
                    <textarea autocomplete="off" v-model="item.suggest" rows="2" placeholder="如有其他意见，请输入内容，没有意见可不填。" class="textarea"></textarea>
                  </div>
                </div>
                <div class="evaluat-box" v-for="item in teachers" :key="item.id">
                  <div class="title">
                    <v-icon class="icon" name='regular/edit' scale="2"></v-icon>
                    <span class="text">对助理讲师{{item.name}}的问卷调查</span>
                  </div>
                  <yioks-rating class="rating" :star-num.sync='item.starNum'></yioks-rating>
                  <p class="cont-title">存在以下现象</p>
                  <yioks-evaluation class="cont-box" :conts-list.sync='item.contsList'></yioks-evaluation>
                  <p class="cont-title">其他意见</p>
                  <div class="textarea-wrap">
                    <textarea autocomplete="off" v-model="item.suggest" cols="50" rows="2" placeholder="如有其他意见，请输入内容，没有意见可不填。" class="textarea"></textarea>
                  </div>
                </div>-->
                
                <div class="evaluat-box" v-for="(item,index) in teaEvaluatResClass" :key="item.id">
                  <div class="title">
                    <v-icon class="icon" name="regular/edit" scale="2"></v-icon>
                    <span class="text">对培训班整体情况的问卷调查</span>
                  </div>
                  <!--<yioks-rating class="rating" :star-num.sync="item.starNum"></yioks-rating>-->
                  <template v-if="item.contsList.length>0">
                    <p class="cont-title">如存在以下现象请勾选</p>
                    <yioks-evaluation class="cont-box" :conts-list.sync="item.contsList"></yioks-evaluation>
                  </template>
                  
                  <template v-if="item.eva_data_choose.length>0">
                    <p class="cont-title">选择以下现象</p>
                    <div class="cont_evalua-root">
                      <div class="item-wrap evaluation_checked" v-for="(it,id) in item.eva_data_choose" :key="it.id" style="display:flex;margin-bottom:10px;width:100%">
                        <div style="display:flex;align-items: flex-start;width:100%">
                          <div style="width:30%">
                            <span style="color:#f88594;margin-right:2px">*</span><span :title="it.text" >{{it.text}}</span>
                          </div>
                          <div style="margin-left:20px;width:20%" >
                            <el-radio-group v-model="it.is_option" @change="(it.content = '')">
                              <el-radio  label="是" border >是</el-radio>
                              <el-radio  label="否" border >否</el-radio>
                            </el-radio-group>
                          </div>
                          <div style="width:46%" v-show="(it.write_content ==='是' && it.is_option==='是') || (it.write_content ==='否' && it.is_option==='否' )">
                            <el-input v-model="it.content" placeholder="请输入内容，必填" maxlength="100" show-word-limit></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <p class="cont-title">情况反馈</p>
                  <div class="textarea-wrap">
                    <textarea
                      autocomplete="off"
                      v-model="item.suggest"
                      rows="2"
                      placeholder="如有其他情况反馈，请输入内容，没有可不填。"
                      class="textarea"
                      maxlength="100"
                    ></textarea>
                    <span class="length-tip">{{item.suggest.length}}/100</span>
                  </div>
                </div>
                
                <div class="evaluat-box" v-for="item in teaEvaluatRes" :key="item.id">
                  <div class="title">
                    <v-icon class="icon" name="regular/edit" scale="2"></v-icon>
                    <span class="text">对{{item.type}}{{item.name}}的问卷调查</span>
                  </div>
                  <div style="text-align: center;font-size: 18px;margin-bottom: 10px;">
                    对{{item.type}}{{item.name}}的综合满意度
                  </div>
                  <yioks-rating class="rating" :star-num.sync="item.starNum"></yioks-rating>
                  <div >
                    <p class="cont-title">如存在以下现象请勾选</p>
                    <yioks-evaluation class="cont-box" :conts-list.sync="item.contsList"></yioks-evaluation>
                  </div>
                  <p class="cont-title">情况反馈</p>
                  <div class="textarea-wrap">
                    <textarea
                      autocomplete="off"
                      v-model="item.suggest"
                      rows="2"
                      placeholder="如有其他情况反馈，请输入内容，没有可不填。"
                      class="textarea"
                      maxlength="100"
                    ></textarea>
                    <span class="length-tip">{{item.suggest.length}}/100</span>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <div class="post-btn">
        <div class="btn save" @click="tipsFlag=true">提交</div>
        <div class="btn cancel" @click="goBack">取消</div>
      </div>
      <yioks-tips :showTips="backComfim" tips="确定放弃修改并返回吗？" @hideTips="backComfimDialog"></yioks-tips>
      <yioks-tips :showTips="tipsFlag" :tips="$options._myOpt.tipMsg" @hideTips="hideTipsDialog"></yioks-tips>
    </div>
  </div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";
import createScrollOpt from "@/assets/js/vuescrollOption";
import { getRatingInfo, saveOrgEvaluat } from "@/api/agency/agency";
import { correctStatus } from "@/assets/js/apiStatus";
import { transData, paramsEvalData,transContsList } from "@/assets/js/evaluation";
const HOSTURL = process.env.VUE_APP_URL;
const SPLIT_CHAR = ",";

export default {
  name: "OrgCreateEvaluation",
  _myOpt: {
    vuescrollOpt: createScrollOpt(),
    tipMsg: "提交后不可更改，是否确定提交？"
  },
  props: {
    classId: {}
  },
  components: {
    "v-icon": Icon,
    user: () => import("./components/EvaluatUser"),
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-rating": () => import("@/components/Rating/Rating"),
    "yioks-evaluation": () => import("@/components/EvaluaConts/EvaluaConts"),
    "yioks-tips": () => import("@/components/Tips/Dialog")
  },
  created() {
    this.ratingInfo();
  },
  data() {
    return {
      backComfim: false,
      tipsFlag: false,
      classInfo: {},
      dataPhase:{},
      teaEvaluatRes: [],
      teaEvaluatResClass: [],
    };
  },
  methods: {
    backComfimDialog(bool, sure) {
      this.backComfim = bool;
      if (sure) {
        this.$router.push({
        name: "OrgEvaluationList"
      });
      } else {
      }
    },
    // 是否确定提交数据弹窗
    hideTipsDialog(bool, sure) {
      this.tipsFlag = bool;
      if (sure) {
        // 提交数据
        this.saveEvaluat();
      } else {
      }
    },
    saveEvaluat() {
      // 选择是否的判断 必须选
      let ab = 0; // 选项是否选择
      let ac = 0; // 如需要填内容 是否填了
      this.teaEvaluatResClass.map(item=>{
        item.eva_data_choose.map(it=>{
          if(it.is_option === ''){
            ab = 1;
          }
          if(it.is_option !== '' && it.is_option ===it.write_content && it.content ===''){
            ac = 1;
          }
        })
      })
      if(ab){
        this.$message.error("请选择带 * 的必选项。");
        return;
      }
      if(ac){
        this.$message.error("请填写带 * 的选项内容");
        return;
      }
  
      const evalData = paramsEvalData(this.teaEvaluatRes)
      const evalDataClass = paramsEvalData(this.teaEvaluatResClass)

      if (evalData.some(({ star }) => star === 0)) {
        this.$message.error("星级评价为必评项");
        return;
      }
      saveOrgEvaluat({
        tea_eval_data: JSON.stringify(evalData),
        tea_eval_data_class: JSON.stringify(evalDataClass),
        c_id: this.classId
      }).then(({ data }) => {
        if (data.status === correctStatus) {
          // Header调查数量-1
          this.$store.commit("updateEvaNum", this.$store.state.evaNum - 1);
          this.$router.push({
        name: "OrgEvaluationList"
      });
        } else {
        }
      });
    },
    ratingInfo() {
      getRatingInfo({ c_id: this.classId }).then(({ data }) => {
        if (data.status === correctStatus) {
          const { result } = data;
          const { class_info, eva_data,eva_data_goalkeeper, eva_data_physical,dataPhase,eva_data_class} = result;
          if (dataPhase && dataPhase.length > 0){
            this.dataPhase={
              start_date:dataPhase[0].start_date,
              start_date1:dataPhase[1].start_date,
              end_date:dataPhase[0].end_date,
              end_date1:dataPhase[1].end_date,
            }
          }

          this.classInfo = {
            ...class_info,
            moment_picture: class_info.moment_picture
              ? HOSTURL + class_info.moment_picture
              : ""
          };
          const offTeachIds = String(this.$yioks
            .nullToStr(class_info.teacher_off_ids))
            .split(SPLIT_CHAR);
          const offTeachNames = this.$yioks
            .nullToStr(class_info.teacher_off_name)
            .split(SPLIT_CHAR);
          this.teaEvaluatRes.push(...transData(offTeachIds, offTeachNames, eva_data, "主讲师","official"));
          if(class_info.teacher_ids&&class_info.teacher_name){
            const teachersIds = this.$yioks
            .nullToStr(class_info.teacher_ids)
            .split(SPLIT_CHAR);
            const teachersNames = this.$yioks
            .nullToStr(class_info.teacher_name)
            .split(SPLIT_CHAR);
            this.teaEvaluatRes.push(...transData(teachersIds, teachersNames, eva_data, "助理讲师","assistant"));
          }
          if(class_info.lecturer_assistant_ids&&class_info.lecturer_assistant_name){
            const lecturerAssistantIds = this.$yioks
            .nullToStr(class_info.lecturer_assistant_ids)
            .split(SPLIT_CHAR);
            const lecturerAssistantNames = this.$yioks
            .nullToStr(class_info.lecturer_assistant_name)
            .split(SPLIT_CHAR);
            this.teaEvaluatRes.push(...transData(lecturerAssistantIds, lecturerAssistantNames, eva_data, "讲师助理","lecturer_assistant"));
          }
          if(eva_data_goalkeeper){
            const goalkeeperIds = ["0"];
            const goalkeeperNames = ["守门员专项讲师"];
            this.teaEvaluatRes.push(...transData(goalkeeperIds, goalkeeperNames, eva_data_goalkeeper, "","goalkeeper"));
          }
          if(eva_data_physical){
            const physicalIds = [""];
            const physicalNames = ["体能专项讲师"];
            this.teaEvaluatRes.push(...transData(physicalIds, physicalNames, eva_data_physical, "","physical"));
          }
          if(eva_data_class){
            const classIds = [""];
            const classNames = ["培训班整体情况"];
            const eva_data = [];
            const eva_data_choose = [];
            eva_data_class.map(item=>{
              if(item.template_type === 'check'){
                eva_data.push(item);
              }
              if(item.template_type === 'choose'){
                let itt = {
                  ...item,
                  is_option:"",
                  content:"",
                }
                eva_data_choose.push(itt);
              }
            })
            this.teaEvaluatResClass.push(...transData(classIds, classNames, eva_data, "","class"));
            this.teaEvaluatResClass.map(item=>{
              item.eva_data_choose =  transContsList(eva_data_choose);
            })
          }
        } else {
        }
      });
    },
    goBack() {
      this.backComfim = true;
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/evaluation'
  .evaluation_checked
    .el-radio.is-bordered
      color:white
    .el-input__suffix
      top: 10px;
    .el-form-item
      margin-bottom 0
</style>
